import { Howl } from 'howler';
import { CDN_URL } from '../../env';

/**
 * ALL THE SOUNDS!
 */
export enum SoundSE {
  CLICK = 'CLICK',
  DEATH = 'DEATH',
  NUKE = 'NUKE',
}

export const soundSrcRaw = [
  [SoundSE.CLICK, `${CDN_URL}/sounds/snap.wav`],
  [SoundSE.DEATH, `${CDN_URL}/sounds/death.wav`],
  [SoundSE.NUKE, `${CDN_URL}/sounds/nuke.mp3`],
];

export const soundSrc = Object.fromEntries(
  (soundSrcRaw as [SoundSE, string][]).map(([key, src]) => [
    key,
    new Howl({ src }),
  ]),
);
